var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(0.5)",
    fill: "#E53323"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1875 17.375C18.2612 17.375 17.445 17.8307 16.9323 18.5236L12.4997 16.2539C12.5733 16.003 12.625 15.7431 12.625 15.4688C12.625 15.0967 12.5487 14.743 12.4169 14.4176L17.0558 11.6261C17.5721 12.232 18.3309 12.625 19.1875 12.625C20.7384 12.625 22 11.3634 22 9.8125C22 8.26159 20.7384 7 19.1875 7C17.6366 7 16.375 8.26159 16.375 9.8125C16.375 10.1699 16.4486 10.5089 16.5707 10.8237L11.918 13.6234C11.4022 13.0355 10.6543 12.6562 9.8125 12.6562C8.26159 12.6562 7 13.9178 7 15.4688C7 17.0197 8.26159 18.2812 9.8125 18.2812C10.7541 18.2812 11.5841 17.8122 12.0948 17.0998L16.5128 19.3622C16.4315 19.6248 16.375 19.8984 16.375 20.1875C16.375 21.7384 17.6366 23 19.1875 23C20.7384 23 22 21.7384 22 20.1875C22 18.6366 20.7384 17.375 19.1875 17.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.945caf719f2c185b6300bd6a9fc78c1c.svg";
export { ForwardRef as ReactComponent };